import AddAddressModal from './AddAddressModal';

export default AddAddressModal;


// WEBPACK FOOTER //
// ./src/components/AddAddressModal/index.jsx